import moment, { Moment } from 'moment-timezone';

type TParsingDate = (date: string | Date | Moment | undefined | null) => Moment;

export const parsingDate: TParsingDate = (date) =>
  moment(date);
